import type { SVGProps } from 'react'
import * as React from 'react'

const buttonIconRegisterExternalPayment = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={48} height={48} rx={24} fill="#2ACC88" />
    <g clipPath="url(#clip0_3147_12942)">
      <g clipPath="url(#clip1_3147_12942)">
        <path
          d="M32.7717 14.8845H14.151C13.0083 14.8845 12.082 15.78 12.082 16.8845V28.8845C12.082 29.9891 13.0083 30.8845 14.151 30.8845H32.7717C33.9143 30.8845 34.8407 29.9891 34.8407 28.8845V16.8845C34.8407 15.78 33.9143 14.8845 32.7717 14.8845Z"
          stroke="white"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12.082 20.8845H34.8407" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <path
        d="M33.3333 34.1667C35.1743 34.1667 36.6667 32.6743 36.6667 30.8333C36.6667 28.9924 35.1743 27.5 33.3333 27.5C31.4924 27.5 30 28.9924 30 30.8333C30 32.6743 31.4924 34.1667 33.3333 34.1667Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M33.2959 28.8999V32.8999" stroke="#2ACC88" strokeWidth={0.6} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M34.3583 29.561H32.9208C32.7429 29.561 32.5723 29.6313 32.4465 29.7563C32.3207 29.8813 32.25 30.0509 32.25 30.2277C32.25 30.4045 32.3207 30.5741 32.4465 30.6991C32.5723 30.8241 32.7429 30.8944 32.9208 30.8944H33.8792C34.0571 30.8944 34.2277 30.9646 34.3535 31.0896C34.4793 31.2147 34.55 31.3842 34.55 31.561C34.55 31.7378 34.4793 31.9074 34.3535 32.0324C34.2277 32.1575 34.0571 32.2277 33.8792 32.2277H32.25"
        stroke="#2ACC88"
        strokeWidth={0.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3147_12942">
        <rect width={30} height={25} fill="white" transform="translate(9 11.5)" />
      </clipPath>
      <clipPath id="clip1_3147_12942">
        <rect width={24.8276} height={24} fill="white" transform="translate(11.0479 10.8845)" />
      </clipPath>
    </defs>
  </svg>
)

export default buttonIconRegisterExternalPayment
